/* eslint-disable */ 
/* tslint:disable */ 
 
export interface AdGroupDataScopeDto {
  parameter?: DataScopeGeneric;
  values?: DataScopeGeneric[] | null;
}

export interface AdGroupDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
}

export interface AdGroupsAndDataScopesGroupsDto {
  usedGroups?: string[] | null;
  groups?: string[] | null;
  dataScopeGroups?: string[] | null;
}

export interface AddAsiteDocumentsSyncClientLogCommand {
  model?: AsiteDocumentsSyncClientLogDto;
}

export interface AddDataScopeCommand {
  /** @format int32 */
  roleId?: number;

  /** @format int32 */
  dataScopeId?: number;

  /** @format int32 */
  valueId?: number;
  groupIds?: string[] | null;
}

export interface AddFastDraftRelaticsSyncClientLogCommand {
  model?: FastDraftRelaticsNotification;
}

export interface AddRelaticsForceSyncCommand {
  /** @format int32 */
  relaticsConfigurationFolderId?: number | null;
}

export interface Aggregate {
  field?: string | null;
  aggregate?: string | null;
}

export interface ApiResponse {
  /** @format int32 */
  statusCode?: number;

  /** @format int32 */
  response?: number | null;
  messages?: string | null;
  error?: boolean;
}

export interface AsiteAttributeBlModel {
  b_WP?: string | null;
  b_Org?: string | null;
  b_Obj?: string | null;
  b_ICodeOrWBS?: string | null;
  b_DocType?: string | null;
  b_Fase?: string | null;
  b_Datum?: string | null;
  b_WCode?: string | null;
  b_Infra?: string | null;
  b_Object?: string | null;
  b_Fase_OBS?: string | null;
  b_Fase_OBS_ALG?: string | null;
  b_Alt_Ref?: string | null;
  b_System?: string | null;
}

export interface AsiteAttributeValueDto {
  code?: string | null;
  name?: string | null;
  asiteCustomAttributeCode?: string | null;
  asiteCustomAttributeName?: string | null;
}

export interface AsiteCustomAttributeTypeDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface AsiteDocumentBlModel {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  asiteDocumentsSyncLogId?: number | null;

  /** @format int32 */
  documentId?: number;

  /** @format int32 */
  revisionId?: number;
  status?: string | null;

  /** @format int32 */
  statusId?: number | null;
  link?: string | null;

  /** @format date-time */
  syncDate?: Date;

  /** @format int32 */
  folderId?: number;
  folderName?: string | null;
  docTypeAttribute?: string | null;
  hashFolderId?: string | null;
  fileType?: string | null;
  documentTitle?: string | null;
  workspaceName?: string | null;

  /** @format int32 */
  workspaceId?: number;
  processing?: boolean;
  documentRef?: string | null;

  /** @format date-time */
  documentDate?: Date;

  /** @format double */
  fileSize?: number | null;

  /** @format date-time */
  b_Datum?: Date;
  checked?: boolean;
  fileGuid?: string | null;
  revNo?: string | null;
  forceSync?: boolean;
  phase?: string | null;
  wbsValue?: string | null;
  attachment?: string | null;
  filePath?: string | null;
  purposeOfIssue?: string | null;

  /** @format int32 */
  purposeOfIssueId?: number | null;

  /** @format date-time */
  publishingDate?: Date;

  /** @format date-time */
  modificationDate?: Date;

  /** @format int32 */
  version?: number | null;
  revisionNumber?: string | null;
  publisherName?: string | null;
  restricted?: boolean;
  attributes?: string | null;
  fileName?: string | null;
  fileNameDisplay?: string | null;

  /** @format int32 */
  relaticsImportErrorCount?: number;

  /** @format int32 */
  relaticsDocumentsSyncImportLogId?: number | null;
  asiteAttribute?: AsiteAttributeBlModel;
  isLink?: boolean;

  /** @format int32 */
  asiteDocumentDocTypeId?: number | null;
  asiteDocumentDocTypeName?: string | null;

  /** @format int32 */
  relaticsDocumentsSyncLogId?: number | null;
  reviewByContractorsFirst?: boolean;
  fromDatabase?: boolean;
}

export interface AsiteDocumentStatusDto {
  /** @format int32 */
  statusId?: number;
  statusName?: string | null;
}

export interface AsiteDocumentsSyncClientLogDto {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: Date;
  simpleMessage?: string | null;
  asiteSyncClientLogType?: EAsiteSyncClientLogType;
  error?: boolean;

  /** @format int32 */
  relaticsDocumentsSyncLogId?: number;
  fileNameDocumentSend?: string | null;
  fileNameDocumentResponse?: string | null;
  asiteSyncEventType?: EAsiteSyncEventType;
}

export interface AsitePurposeOfIssueBlModel {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  purposeOfIssueId?: number;
  purposeOfIssueName?: string | null;

  /** @format int32 */
  workspaceId?: number;
  processing?: boolean;
}

export interface AsiteSyncLogDto {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  startDate?: Date;

  /** @format date-time */
  endDate?: Date;
  status?: string | null;

  /** @format int32 */
  syncType?: number;
  emailSend?: string | null;
  message?: string | null;
}

export interface AsiteSyncLogDtoGridDataResult {
  data?: AsiteSyncLogDto[] | null;

  /** @format int32 */
  total?: number;
}

export interface BaseDownloadFile {
  name?: string | null;

  /** @format byte */
  content?: string | null;
}

export interface BasicUserDto {
  /** @format uuid */
  id?: string;
  active?: boolean;

  /** @format int32 */
  internalId?: number;

  /** @format uuid */
  relaticsIdToetsing?: string | null;

  /** @format uuid */
  relaticsId?: string | null;
  axiCode?: string | null;
  asiteName?: string | null;
  activeRelatics?: boolean;
  name?: string | null;
  firstName?: string | null;
  emailAddress?: string | null;
}

export interface ConfigurationFolderDto {
  workspaceName?: string | null;

  /** @format int32 */
  folderId?: number;
  folderName?: string | null;
  fullPath?: string | null;

  /** @format date-time */
  lastSyncData?: Date;
  createdBy?: string | null;

  /** @format date-time */
  createdOn?: Date;
}

export interface ConfigurationFolderDtoGridDataResult {
  data?: ConfigurationFolderDto[] | null;

  /** @format int32 */
  total?: number;
}

export interface CreateDrainageCodValueCommand {
  /** @format int32 */
  codType?: number;
  codValue?: string | null;
}

export interface CreateDrainageCommand {
  model?: DrainageDetailsDto;
}

export interface CreateLicenseAppealCommand {
  model?: LicenseAppealDetailsDto;
}

export interface CreateLicenseAppealDocumentCommand {
  model?: LicenseAppealDocumentDto;
}

export interface CreateLicenseCodProjectCommand {
  model?: LicenseCodProjectDto;
}

export interface CreateLicenseCommand {
  model?: LicenseDetailsDto;
}

export interface CreateLicensePhaseCommand {
  model?: LicensePhaseDto;
}

export interface DataScopeDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  dataScopeId?: number;

  /** @format int32 */
  valueId?: number;
  groupIds?: string[] | null;
}

export interface DataScopeGeneric {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface DataSourceRequest {
  /** @format int32 */
  take?: number;

  /** @format int32 */
  skip?: number;

  /** @format int32 */
  page?: number;

  /** @format int32 */
  pageSize?: number;
  sort?: Sort[] | null;
  aggregate?: Aggregate[] | null;
  filter?: Filters;
}

export interface DeleteDrainageCodValueCommand {
  /** @format int32 */
  codType?: number;

  /** @format int32 */
  codId?: number;
}

export interface DeleteLicenseAppealCommand {
  /** @format int32 */
  appealId?: number;
}

export interface DeleteLicenseCommand {
  /** @format int32 */
  licenseId?: number;
}

export interface DocumentLinksForceSynResponse {
  success?: boolean;
  errorMessage?: string | null;
}

export interface DrainageCodBaseDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface DrainageCodDestinationTypeDto {
  /** @format int32 */
  id?: number;
  name?: string | null;

  /** @format double */
  value?: number | null;

  /** @format int32 */
  unit?: number;
  isFieldGenerated?: boolean;
}

export interface DrainageCodProjectStatusDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface DrainageCodTypeDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export type DrainageCodValuesViewDto = object;

export interface DrainageDetailsDto {
  /** @format int32 */
  id?: number;
  drainageZoneName?: string | null;
  hasLicense?: boolean;

  /** @format date-time */
  licensedUntil?: Date;

  /** @format double */
  peakFlowRate?: number | null;

  /** @format double */
  stationaryFlowRate?: number | null;

  /** @format double */
  maximumDailyInflationFlow?: number | null;

  /** @format double */
  licensedAnnualInflationRate?: number | null;

  /** @format date-time */
  drainageStartDate?: Date;

  /** @format date-time */
  drainageEndDate?: Date;

  /** @format int64 */
  drainageDurationMin?: number | null;

  /** @format int64 */
  drainageDurationMax?: number | null;
  isMaxInfluenceRadiusPerStrand?: boolean;
  zoneOfInfluenceLinkShapefile?: string | null;
  zoneOfInfluenceLinkShapefileHyper?: string | null;
  isIndoorConstructionPit?: boolean;
  isDrainageInSBZ?: boolean;
  isScopeDrainageSBZ?: boolean;
  hasFloorPlan?: boolean;
  floorPlanLink?: string | null;
  floorPlanLinkHyper?: string | null;
  hasCumulativeEffectsOutlets?: boolean;
  cumulativeEffectsOutletsDescription?: string | null;
  hasCumulativeEffectsDischarge?: boolean;
  cumulativeEffectsDischargeDescription?: string | null;
  drainageDestinationDescription?: string | null;

  /** @format double */
  value?: number | null;

  /** @format int32 */
  unit?: number;
  standardsForDrainageWater?: string | null;
  flowRateReuse?: string | null;
  hasDrainageNotaHGS?: boolean;
  drainageNotaHGSLink?: string | null;
  drainageNotaHGSLinkHyper?: string | null;
  licenseWorkflowStatus?: string | null;
  drainageShapefile?: string | null;
  cumulativeEffectsAdditionalDescription?: string | null;

  /** @format int64 */
  dischargePointsNumber?: number | null;

  /** @format int64 */
  returnWellsNumber?: number | null;
  returnWellsLocation?: string | null;
  returnWaterConditions?: string | null;
  reuseNatureDescription?: string | null;
  reuseConditions?: string | null;
  destinationDrainageWaterAdditionalDescription?: string | null;
  drainageDataAdditionalDescription?: string | null;
  drainageInfluencesAdditionalDescription?: string | null;
  floorPlanAdditionalDescription?: string | null;
  projectInfoAdditionalDescription?: string | null;

  /** @format double */
  totalVolumeOfGroundwaterPumped?: number | null;
  licenseCodProject?: LicenseCodProjectDto;
  license?: LicenseInfoDto;
  drainageCodType?: DrainageCodTypeDto[] | null;
  drainageCodProjectStatus?: DrainageCodProjectStatusDto;
  drainageCodDestinationType?: DrainageCodDestinationTypeDto[] | null;
  startStatus?: DrainageCodTypeDto;
  licenseProgressMapper?: DrainageCodBaseDto[] | null;
  endStatus?: DrainageCodTypeDto;
  dischargePoints?: DrainageDischargePointDto[] | null;
}

export interface DrainageDischargePointDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  drainageId?: number;
  details?: string | null;
  drainagePoints?: string | null;
  hasConditions?: boolean;
  conditions?: string | null;
}

export interface DrainageDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  licenseCodProjectId?: number;
  licenseCodProjectName?: string | null;

  /** @format int32 */
  licenseId?: number | null;
  licenseName?: string | null;
  licenseReference?: string | null;
  drainageZoneName?: string | null;

  /** @format int32 */
  drainageCodTypeId?: number | null;
  drainageCodTypeName?: string | null;
  hasLicense?: boolean;

  /** @format int32 */
  drainageCodStatusId?: number;
  drainageCodStatusName?: string | null;

  /** @format int32 */
  drainageLicenseCodStatusId?: number;
  drainageCodeLicenseStatusName?: string | null;

  /** @format date-time */
  licensedUntil?: Date;

  /** @format double */
  peakFlowRate?: number | null;

  /** @format double */
  stationaryFlowRate?: number | null;

  /** @format double */
  maximumDailyInflationFlow?: number | null;

  /** @format double */
  licensedAnnualInflationRate?: number | null;

  /** @format date-time */
  drainageStartDate?: Date;

  /** @format date-time */
  drainageEndDate?: Date;

  /** @format int64 */
  drainageDurationMin?: number | null;

  /** @format int64 */
  drainageDurationMax?: number | null;
  isMaxInfluenceRadiusPerStrand?: boolean;
  zoneOfInfluenceLinkShapefile?: string | null;
  zoneOfInfluenceLinkShapefileHyper?: string | null;
  isIndoorConstructionPit?: boolean;
  isDrainageInSBZ?: boolean;
  isScopeDrainageSBZ?: boolean;
  hasFloorPlan?: boolean;
  floorPlanLink?: string | null;
  floorPlanLinkHyper?: string | null;
  hasCumulativeEffectsOutlets?: boolean;
  cumulativeEffectsOutletsDescription?: string | null;
  hasCumulativeEffectsDischarge?: boolean;
  cumulativeEffectsDischargeDescription?: string | null;

  /** @format int32 */
  drainageCodDestinationTypeId?: number | null;
  drainageCodDestinationTypeName?: string | null;
  drainageDestinationDescription?: string | null;

  /** @format int64 */
  dischargePointsNumber?: number | null;
  dischargePoints?: DrainageDischargePointDto[] | null;

  /** @format int64 */
  returnWellsNumber?: number | null;
  returnWellsLocation?: string | null;
  returnWaterConditions?: string | null;
  reuseNatureDescription?: string | null;
  reuseConditions?: string | null;

  /** @format double */
  value?: number | null;

  /** @format int32 */
  unit?: number;
  standardsForDrainageWater?: string | null;
  flowRateReuse?: string | null;
  hasDrainageNotaHGS?: boolean;
  drainageNotaHGSLink?: string | null;
  drainageNotaHGSLinkHyper?: string | null;
  licenseWorkflowStatus?: string | null;
  drainageShapefile?: string | null;

  /** @format int32 */
  startStatusId?: number;

  /** @format int32 */
  endStatusId?: number;
  drainageCodDestinationTypes?: DrainageCodDestinationTypeDto[] | null;
  drainageLicensesProgresses?: string | null;

  /** @format double */
  totalVolumeOfGroundwaterPumped?: number | null;
  licenseProgressesStatuses?: string | null;
  lastLicenseStatus?: string | null;
}

export interface DrainageDtoGridDataResult {
  data?: DrainageDto[] | null;

  /** @format int32 */
  total?: number;
}

/**
 * @format int32
 */
export type EAsiteSyncClientLogType = 1 | 2;

/**
 * @format int32
 */
export type EAsiteSyncEventType = 0 | 1 | 2;

/**
 * @format int32
 */
export type ELicenseWorkflowStatus = 1 | 2 | 3 | 4;

/**
 * @format int32
 */
export type ERelaticsSyncEventType = 0 | 1 | 2;

export interface ErrorRelaticsImportViewModel {
  key?: string | null;
  message?: string | null;
}

export interface FastDraftRelaticsNotification {
  item?: FastDraftRelaticsTempLogDto;
  method?: string | null;
}

export interface FastDraftRelaticsSyncImportLogDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  fastDraftSyncClientLogId?: number;

  /** @format date-time */
  startDate?: Date;

  /** @format date-time */
  endDate?: Date;
  error?: boolean;
  service?: string | null;
  documentType?: string | null;
  fileNameDocumentSend?: string | null;
  fileNameDocumentResponse?: string | null;
  message?: string | null;
  runed?: boolean;
  executing?: boolean;

  /** @format int32 */
  countIndex?: number | null;

  /** @format int32 */
  retries?: number;
}

export interface FastDraftRelaticsTempLogDto {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  date?: Date;
  message?: string | null;
  error?: boolean;

  /** @format int32 */
  fastDraftSyncClientLogId?: number | null;

  /** @format int32 */
  fastDraftRelaticsSyncImportLogId?: number | null;
  fileNameDocumentSend?: string | null;
  fileNameDocumentResponse?: string | null;
}

export interface FastDraftSyncClientLogDto {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  startDate?: Date;

  /** @format date-time */
  endDate?: Date;
  status?: string | null;
  message?: string | null;
  client?: string | null;
  triggerBy?: string | null;
  syncType?: string | null;
}

export interface FastDraftSyncClientLogDtoGridDataResult {
  data?: FastDraftSyncClientLogDto[] | null;

  /** @format int32 */
  total?: number;
}

export interface Filter {
  field?: string | null;
  operator?: string | null;
  value?: string | null;
  logic?: string | null;
  filters?: Filter[] | null;
}

export interface Filters {
  logic?: string | null;
  filters?: Filter[] | null;
}

export type GetAdGroupsQuery = object;

export type GetAllAppealDocumentStatusesQuery = object;

export type GetAllAppealInstancesQuery = object;

export type GetAllAppealStatusesQuery = object;

export type GetAllAsiteDocumentsSyncClientLogQuery = object;

export type GetAllCodValuesQuery = object;

export type GetAllDecisionIndicatorsQuery = object;

export type GetAllDrainageIndicatorsQuery = object;

export interface GetAllDrainageQuery {
  data?: DataSourceRequest;
}

export type GetAllIndicatorsQuery = object;

export type GetAllLicenseProjectsQuery = object;

export type GetAllLicensesInfoQuery = object;

export type GetAllProgressesQuery = object;

export type GetAllSubmittedToQuery = object;

export type GetLicenseWorkflowStatusesQuery = object;

export type GetModulesQuery = object;

export interface GetOverviewDataQuery {
  data?: DataSourceRequest;
}

export interface GetUserRoleByModuleQuery {
  moduleName?: string | null;
}

export interface GetUserRolesByModuleNamesQuery {
  moduleNameList?: string[] | null;
  userEmail?: string | null;
}

export interface LicenseAppealDatesDto {
  /** @format date-time */
  appealProcedureStartDate?: Date;

  /** @format date-time */
  appealProcedureEndDate?: Date;
}

export interface LicenseAppealDetailsDto {
  /** @format int32 */
  id?: number;
  name?: string | null;

  /** @format date-time */
  submittedOn?: Date;

  /** @format date-time */
  expectedPronunciation?: Date;
  submittedBy?: string | null;
  procedure?: string | null;

  /** @format int32 */
  licenseId?: number;
  licenseName?: string | null;
  status?: LicenseCodTableDto;
  submittedToNavigation?: LicenseCodTableDto;
}

export interface LicenseAppealDocumentDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  licenseAppealId?: number;
  link?: string | null;
  description?: string | null;
  licenseDocumentStatus?: LicenseCodTableDto;
}

export interface LicenseAppealDocumentPowerBiDto {
  link?: string | null;
  type?: string | null;
}

export interface LicenseAppealGeneralViewModel {
  /** @format date-time */
  appealProcedureStartDate?: Date;

  /** @format date-time */
  appealProcedureEndDate?: Date;
  licenseAppeals?: LicenseAppealOverviewDto[] | null;
}

export interface LicenseAppealOverviewDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  submittedBy?: string | null;

  /** @format date-time */
  submittedOn?: Date;
}

export interface LicenseAppealPowerBiDto {
  naamBeroep?: string | null;
  status?: string | null;

  /** @format date-time */
  ingediendOp?: Date;

  /** @format date-time */
  verwachteUitspraak?: Date;
  ingediendDoor?: string | null;
  ingediendBij?: string | null;
  procedure?: string | null;
  documents?: LicenseAppealDocumentPowerBiDto[] | null;
}

export interface LicenseCodProjectDto {
  /** @format int32 */
  id?: number;
  name?: string | null;

  /** @format int32 */
  orderIndex?: number;
}

export interface LicenseCodTableDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface LicenseDetailsDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  link?: string | null;
  reference?: string | null;
  overWrittenPart?: string | null;

  /** @format date-time */
  projectDate?: Date;
  done?: boolean | null;
  submittedBy?: string | null;
  description?: string | null;

  /** @format date-time */
  ovcdate?: Date;
  ovclink?: string | null;
  ovcapplicable?: boolean | null;

  /** @format date-time */
  submitApplicationDate?: Date;
  submitApplicationLink?: string | null;

  /** @format date-time */
  submitApplicationDateFullAndReceive?: Date;
  submitApplicationLinkFullAndReceive?: string | null;

  /** @format date-time */
  publicInvestigationStartDate?: Date;

  /** @format date-time */
  publicInvestigationEndDate?: Date;

  /** @format date-time */
  publicInvestigationEndDateFullAndReceive?: Date;
  publicInvestigationLink?: string | null;
  publicInvestigationApplicable?: boolean | null;
  publicInvestigationEnvironmentCounterLink?: string | null;

  /** @format date-time */
  decisionDate?: Date;
  decisionLink?: string | null;

  /** @format date-time */
  decisionDateFullAndReceive?: Date;
  decisionLinkFullAndReceive?: string | null;
  decisionApplicable?: boolean | null;

  /** @format date-time */
  progressStartDate?: Date;

  /** @format date-time */
  progressEndDate?: Date;

  /** @format date-time */
  appealProcedureEndDate?: Date;

  /** @format date-time */
  appealProcedureStartDate?: Date;
  administrativeApplicable?: boolean;

  /** @format date-time */
  administrativeDateFullAndReceived?: Date;
  administrativeLinkFullAndReceive?: string | null;

  /** @format date-time */
  administrativeBeginDate?: Date;

  /** @format date-time */
  administrativeEndDate?: Date;
  descriptionIntern?: string | null;
  permitSubArea?: LicenseCodProjectDto;
  ovcstatus?: LicenseCodTableDto;
  submitApplicationSubmittedToNavigation?: LicenseCodTableDto;
  submitApplicationStatusStart?: LicenseCodTableDto;
  submitApplicationStatusEnd?: LicenseCodTableDto;
  publicInvestigationStatusStart?: LicenseCodTableDto;
  publicInvestigationStatusEnd?: LicenseCodTableDto;
  decisionStatus?: LicenseCodTableDto;
  licensesProgress?: LicenseCodTableDto[] | null;
  licenseCodWorkflowStatus?: LicenseCodTableDto;
  administrativeStatusStart?: LicenseCodTableDto;
  administrativeStatusEnd?: LicenseCodTableDto;
}

export interface LicenseInfoDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  reference?: string | null;
  licenseWorkflowStatus?: string | null;
  licensesProgress?: DrainageCodBaseDto[] | null;
  lastLicenseProgress?: string | null;
}

export interface LicenseOverviewDto {
  /** @format int32 */
  id?: number;
  projectName?: string | null;

  /** @format int32 */
  projectId?: number;
  name?: string | null;
  reference?: string | null;
  submittedBy?: string | null;

  /** @format date-time */
  submitApplicationDate?: Date;
  submitApplicationSubmittedTo?: string | null;

  /** @format date-time */
  submitApplicationDateFullAndReceive?: Date;

  /** @format date-time */
  publicInvestigationStartDate?: Date;

  /** @format date-time */
  publicInvestigationEndDate?: Date;

  /** @format date-time */
  publicInvestigationEndDateFullAndReceive?: Date;

  /** @format date-time */
  ovcDate?: Date;

  /** @format date-time */
  decisionDate?: Date;
  decisionStatus?: string | null;

  /** @format date-time */
  decisionDateFullAndReceive?: Date;
  progress?: string | null;
  overWrittenPart?: string | null;
  hasDraaiboek?: boolean;
  hasNewNodes?: boolean;
  hasProblems?: boolean;

  /** @format int32 */
  submitApplicationStatusStartId?: number | null;

  /** @format int32 */
  submitApplicationStatusEndId?: number | null;

  /** @format int32 */
  publicInvestigationStatusStartId?: number | null;

  /** @format int32 */
  publicInvestigationStatusEndId?: number | null;

  /** @format int32 */
  ovcStatusId?: number | null;

  /** @format int32 */
  decisionStatusId?: number | null;

  /** @format int32 */
  licensePhaseEndStatusId?: number | null;
  workflowStatusName?: string | null;

  /** @format int32 */
  workflowStatusId?: number;
  publicInvestigationNotApplicable?: boolean;
  decisionNotApplicable?: boolean;
  ovcNotapplicable?: boolean;
  link?: string | null;
  submitApplicationLink?: string | null;
  submitApplicationLinkFullAndReceive?: string | null;
  publicInvestigationLink?: string | null;
  ovclink?: string | null;
  decisionLink?: string | null;
  decisionLinkFullAndReceive?: string | null;
  administrativeApplicable?: boolean;

  /** @format date-time */
  administrativeDateFullAndReceived?: Date;
  administrativeLinkFullAndReceive?: string | null;

  /** @format date-time */
  administrativeBeginDate?: Date;

  /** @format date-time */
  administrativeEndDate?: Date;

  /** @format int32 */
  administrativeStatusStartId?: number | null;

  /** @format int32 */
  administrativeStatusEndId?: number | null;
}

export interface LicenseOverviewDtoGridDataResult {
  data?: LicenseOverviewDto[] | null;

  /** @format int32 */
  total?: number;
}

export interface LicensePhaseDto {
  /** @format int32 */
  id?: number;
  name?: string | null;

  /** @format date-time */
  startDate?: Date;
  startLink?: string | null;

  /** @format date-time */
  endDate?: Date;
  endLink?: string | null;

  /** @format int32 */
  licenseId?: number;
  startStatus?: LicenseCodTableDto;
  endStatus?: LicenseCodTableDto;
}

export interface LicensePhasePowerBiDto {
  naamFase?: string | null;

  /** @format date-time */
  uitvoeringVergunningDatumStartWerken?: Date;
  uitvoeringVergunningIndicatorStart?: string | null;
  uitvoeringVergunningLinkStart?: string | null;

  /** @format date-time */
  uitvoeringVergunningDatumEindeWerken?: Date;
  uitvoeringVergunningIndicatorEinde?: string | null;
  uitvoeringVergunningLinkEinde?: string | null;
}

export interface LicensePhaseViewModel {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  executionStartDate?: Date;

  /** @format date-time */
  urbanDevelopmentEndDate?: Date;

  /** @format date-time */
  environmentEndDate?: Date;

  /** @format date-time */
  executionEndDate?: Date;
  workInPhases?: boolean;
  licensePhases?: LicensePhaseDto[] | null;
}

export interface LicensePowerBiDto {
  projectDG?: string | null;
  projectNaam?: string | null;
  projectLink?: string | null;
  projectReferentie?: string | null;
  projectIngediendDoor?: string | null;
  projectStandVanZaken?: string | null;
  projectOmschrijving?: string | null;
  projectOverschrevenDeel?: string | null;

  /** @format date-time */
  projectDate?: Date;

  /** @format date-time */
  startOpmaak?: Date;

  /** @format date-time */
  eindeOpmaak?: Date;

  /** @format date-time */
  indienenAanvraagDatumIndienen?: Date;
  indienenAanvraagIngediendBij?: string | null;
  indienenAanvraagIndicatorIndienen?: string | null;
  indienenAanvraagLinkIngediendDossier?: string | null;

  /** @format date-time */
  indienenAanvraagDatumVollOntvank?: Date;
  indienenAanvraagIndicatorVollOntvank?: string | null;
  indienenAanvraagLinkVollOntvank?: string | null;

  /** @format date-time */
  openbaarOnderzoekAanplakking?: Date;
  openbaarOnderzoekIndicatorAanplakking?: string | null;
  openbaarOnderzoekLinkAanplakking?: string | null;

  /** @format date-time */
  openbaarOnderzoekStarddatum?: Date;

  /** @format date-time */
  openbaarOnderzoekEinddatum?: Date;
  openbaarOnderzoekIndicator?: string | null;
  openbaarOnderzoekNVTAanplakking?: boolean | null;
  openbaarOnderzoekLinkOoOmgevingsloket?: string | null;

  /** @format date-time */
  gpovcDatum?: Date;
  gpovcIndicator?: string | null;
  gpovcLink?: string | null;
  gpovcnvt?: boolean | null;

  /** @format date-time */
  beslissingDatum?: Date;
  beslissingStatus?: string | null;
  beslissingLink?: string | null;

  /** @format date-time */
  beslissingAanplakking?: Date;
  beslissingLinkAanplakking?: string | null;
  beslissingNVT?: boolean | null;
  bestuurlijkeLusVanToepassing?: boolean | null;

  /** @format date-time */
  bestuurlijkeLusAanplakking?: Date;

  /** @format date-time */
  bestuurlijkeLusStartdatumOo?: Date;

  /** @format date-time */
  bestuurlijkeLusEinddatumOo?: Date;
  bestuurlijkeLusIndicator?: string | null;
  bestuurlijkeLusIndicatorEind?: string | null;
  bestuurlijkeLusLinkAanplakking?: string | null;

  /** @format date-time */
  beroepsprocedureStartDatum?: Date;

  /** @format date-time */
  beroepsprocedureEindDatum?: Date;
  appeals?: LicenseAppealPowerBiDto[] | null;

  /** @format date-time */
  uitvoeringVergunningDatumUitvoerbaar?: Date;

  /** @format date-time */
  uitvoeringVergunningVervaltermijnStedenbouw?: Date;

  /** @format date-time */
  uitvoeringVergunningVervaltermijnMilieu?: Date;

  /** @format date-time */
  uitvoeringVergunningDatumVervaltermijn?: Date;
  fases?: LicensePhasePowerBiDto[] | null;
}

export interface LogOutEventCommand {
  userId?: string | null;
}

export interface MethodDto {
  /** @format int32 */
  methodId?: number;
  code?: string | null;
  methodName?: string | null;
}

export interface MethodV2Dto {
  /** @format int32 */
  methodId?: number;
  code?: string | null;
  methodName?: string | null;
}

export interface ModuleMethodsDto {
  /** @format int32 */
  moduleId?: number;
  moduleName?: string | null;
  methods?: MethodDto[] | null;
}

export interface ModuleV2Dto {
  /** @format int32 */
  moduleId?: number;
  moduleName?: string | null;
  methods?: MethodV2Dto[] | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;

  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
}

export interface RelaticsDocumentsSyncImportLogDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  relaticsDocumentsSyncLogId?: number;

  /** @format date-time */
  startDate?: Date;

  /** @format date-time */
  endDate?: Date;
  error?: boolean;
  fileNameDocumentSend?: string | null;
  fileNameDocumentResponse?: string | null;
  message?: string | null;
  runed?: boolean;
  executing?: boolean;
  eventType?: ERelaticsSyncEventType;
}

export interface RelaticsImportResults {
  /** @format int32 */
  asiteDocumentId?: number;
  filePath?: string | null;
  docRef?: string | null;
  errors?: ErrorRelaticsImportViewModel[] | null;
}

export interface RelaticsSyncLogDto {
  /** @format int32 */
  id?: number;

  /** @format date-time */
  startDate?: Date;

  /** @format date-time */
  endDate?: Date;
  status?: string | null;
  emailSend?: string | null;
  message?: string | null;
  errorFilePath?: string | null;
  storagePath?: string | null;
  errorValidation?: boolean;
  fileNameImport?: string | null;
  relaticsConfigurationFolderFullPath?: string | null;
}

export interface RelaticsSyncLogDtoGridDataResult {
  data?: RelaticsSyncLogDto[] | null;

  /** @format int32 */
  total?: number;
}

/**
 * @format int32
 */
export type ReviewUserSource = 0 | 1;

export interface RoleDto {
  /** @format int32 */
  id?: number;
  role?: string | null;
}

export interface Sort {
  field?: string | null;
  dir?: string | null;
}

export type Unit = object;

export interface UpdateAdGroupsByRoleIdCommand {
  /** @format int32 */
  roleId?: number;
  groupIds?: string[] | null;
}

export interface UpdateDataScopeCommand {
  /** @format int32 */
  roleId?: number;

  /** @format int32 */
  oldDataScopeId?: number;

  /** @format int32 */
  dataScopeId?: number;

  /** @format int32 */
  oldValueId?: number;

  /** @format int32 */
  valueId?: number;
  groupIds?: string[] | null;
}

export interface UpdateDrainageCodValueCommand {
  /** @format int32 */
  codType?: number;

  /** @format int32 */
  codId?: number;
  codValue?: string | null;
}

export interface UpdateDrainageCommand {
  model?: DrainageDetailsDto;
}

export interface UpdateLicenseAppealCommand {
  model?: LicenseAppealDetailsDto;
}

export interface UpdateLicenseAppealDocumentCommand {
  model?: LicenseAppealDocumentDto;
}

export interface UpdateLicenseAppealsDatesCommand {
  /** @format int32 */
  licenseId?: number;
  appealDates?: LicenseAppealDatesDto;
}

export interface UpdateLicenseCodProjectCommand {
  model?: LicenseCodProjectDto;
}

export interface UpdateLicenseCommand {
  model?: LicenseDetailsDto;
}

export interface UpdateLicensePhaseCommand {
  model?: LicensePhaseDto;
}

export interface UpdateLicenseWithPhasesCommand {
  model?: LicensePhaseViewModel;
}

export interface UpdateWorkflowStatusCommand {
  /** @format int32 */
  licenseId?: number;
  status?: ELicenseWorkflowStatus;
}

export interface UserModuleView {
  /** @format int32 */
  id?: number;
  name?: string | null;
  emailAddress?: string | null;
}

export interface UserRoleDataScopeDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  userRoleId?: number;

  /** @format int32 */
  dataScopeId?: number;
  dataScopeName?: string | null;

  /** @format int32 */
  valueId?: number;
}

export interface UserRoleDataScopeV2Dto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  userRoleId?: number;

  /** @format int32 */
  dataScopeId?: number;
  dataScopeName?: string | null;

  /** @format int32 */
  valueId?: number;
}

export interface UserRoleDto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  roleId?: number;
  roleName?: string | null;
  hasGlobalAccess?: boolean;
  userRoleDataScopes?: UserRoleDataScopeDto[] | null;
  module?: ModuleMethodsDto;
}

export interface UserRoleV2Dto {
  /** @format int32 */
  id?: number;

  /** @format int32 */
  roleId?: number;
  roleName?: string | null;
  userRoleDataScopes?: UserRoleDataScopeV2Dto[] | null;
  module?: ModuleV2Dto;
  projectIdsWithTargetStatusConfigForContractors?: number[] | null;
}

/**
 * @format int32
 */
export type UserTypeOrganisation = 1 | 2 | 3 | 4;

export interface UsersComboBoxDagboekDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  emailAddress?: string | null;
  fullName?: string | null;

  /** @format uuid */
  relaticsId?: string | null;
}

export interface UsersComboBoxDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  emailAddress?: string | null;
  fullName?: string | null;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.instance.defaults.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      formData.append(
        key,
        property instanceof Blob
          ? property
          : typeof property === "object" && property !== null
          ? JSON.stringify(property)
          : `${property}`,
      );
      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = (format && this.format) || void 0;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      requestParams.headers.common = { Accept: "*/*" };
      requestParams.headers.post = {};
      requestParams.headers.put = {};

      body = this.createFormData(body as Record<string, unknown>);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Lantis API V2
 * @version v2
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  asite = {
    /**
     * No description
     *
     * @tags Asite
     * @name AsiteGetAsiteDocumentStatusesByWorkspaceNameGet
     * @request GET:/api/v2/asite/Asite/GetAsiteDocumentStatusesByWorkspaceName
     * @secure
     * @response `200` `(AsiteDocumentStatusDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteGetAsiteDocumentStatusesByWorkspaceNameGet: (query?: { workspaceName?: string }, params: RequestParams = {}) =>
      this.http.request<AsiteDocumentStatusDto[], ProblemDetails>({
        path: `/api/v2/asite/Asite/GetAsiteDocumentStatusesByWorkspaceName`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asite
     * @name AsiteGetAsiteCustomAttributeTypesGet
     * @request GET:/api/v2/asite/Asite/GetAsiteCustomAttributeTypes
     * @secure
     * @response `200` `(AsiteCustomAttributeTypeDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteGetAsiteCustomAttributeTypesGet: (params: RequestParams = {}) =>
      this.http.request<AsiteCustomAttributeTypeDto[], ProblemDetails>({
        path: `/api/v2/asite/Asite/GetAsiteCustomAttributeTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asite
     * @name AsiteGetAsiteAttributesValueByTypeAndWorkspaceNameGet
     * @request GET:/api/v2/asite/Asite/GetAsiteAttributesValueByTypeAndWorkspaceName
     * @secure
     * @response `200` `(AsiteAttributeValueDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteGetAsiteAttributesValueByTypeAndWorkspaceNameGet: (
      query?: { attributeTypeId?: number; workspaceName?: string },
      params: RequestParams = {},
    ) =>
      this.http.request<AsiteAttributeValueDto[], ProblemDetails>({
        path: `/api/v2/asite/Asite/GetAsiteAttributesValueByTypeAndWorkspaceName`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asite
     * @name AsiteGetAsiteAttributesProductReservationGet
     * @request GET:/api/v2/asite/Asite/GetAsiteAttributesProductReservation
     * @secure
     * @response `200` `(AsiteAttributeValueDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteGetAsiteAttributesProductReservationGet: (
      query?: { applicationCode?: string; workspaceName?: string },
      params: RequestParams = {},
    ) =>
      this.http.request<AsiteAttributeValueDto[], ProblemDetails>({
        path: `/api/v2/asite/Asite/GetAsiteAttributesProductReservation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asite
     * @name AsiteGetAsiteAttributesValueByTypeAndProjectIdGet
     * @request GET:/api/v2/asite/Asite/GetAsiteAttributesValueByTypeAndProjectId
     * @secure
     * @response `200` `(AsiteAttributeValueDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteGetAsiteAttributesValueByTypeAndProjectIdGet: (
      query?: { attributeType?: string; projectId?: number },
      params: RequestParams = {},
    ) =>
      this.http.request<AsiteAttributeValueDto[], ProblemDetails>({
        path: `/api/v2/asite/Asite/GetAsiteAttributesValueByTypeAndProjectId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asite
     * @name AsiteUploadFilePost
     * @request POST:/api/v2/asite/Asite/UploadFile
     * @secure
     * @response `200` `AsiteDocumentBlModel` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteUploadFilePost: (data: { files?: File[]; asiteDocument?: string }, params: RequestParams = {}) =>
      this.http.request<AsiteDocumentBlModel, ProblemDetails>({
        path: `/api/v2/asite/Asite/UploadFile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Asite
     * @name AsiteGetCustomPoiByWorkspaceNameGet
     * @request GET:/api/v2/asite/Asite/GetCustomPoiByWorkspaceName
     * @secure
     * @response `200` `(AsitePurposeOfIssueBlModel)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteGetCustomPoiByWorkspaceNameGet: (query?: { WorkspaceName?: string }, params: RequestParams = {}) =>
      this.http.request<AsitePurposeOfIssueBlModel[], ProblemDetails>({
        path: `/api/v2/asite/Asite/GetCustomPoiByWorkspaceName`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  asiteRelaticsSync = {
    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncGetAsiteSyncLogsPost
     * @request POST:/api/v2/AsiteRelaticsSync/GetAsiteSyncLogs
     * @secure
     * @response `200` `AsiteSyncLogDtoGridDataResult` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteRelaticsSyncGetAsiteSyncLogsPost: (
      data: DataSourceRequest,
      query?: { startDate?: Date; endDate?: Date },
      params: RequestParams = {},
    ) =>
      this.http.request<AsiteSyncLogDtoGridDataResult, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/GetAsiteSyncLogs`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncGetRelaticsSyncLogsPost
     * @request POST:/api/v2/AsiteRelaticsSync/GetRelaticsSyncLogs
     * @secure
     * @response `200` `RelaticsSyncLogDtoGridDataResult` Success
     * @response `204` `void` No Content
     * @response `403` `ProblemDetails` Forbidden
     * @response `404` `ProblemDetails` Not Found
     */
    asiteRelaticsSyncGetRelaticsSyncLogsPost: (
      data: DataSourceRequest,
      query?: { startDate?: Date; endDate?: Date },
      params: RequestParams = {},
    ) =>
      this.http.request<RelaticsSyncLogDtoGridDataResult, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/GetRelaticsSyncLogs`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncGetConfigurationFoldersPost
     * @request POST:/api/v2/AsiteRelaticsSync/GetConfigurationFolders
     * @secure
     * @response `200` `ConfigurationFolderDtoGridDataResult` Success
     * @response `204` `void` No Content
     * @response `403` `ProblemDetails` Forbidden
     * @response `404` `ProblemDetails` Not Found
     */
    asiteRelaticsSyncGetConfigurationFoldersPost: (data: DataSourceRequest, params: RequestParams = {}) =>
      this.http.request<ConfigurationFolderDtoGridDataResult, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/GetConfigurationFolders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncDeleteRelaticsConfigurationFolderDelete
     * @request DELETE:/api/v2/AsiteRelaticsSync/{folderId}
     * @secure
     * @response `200` `boolean` Success
     * @response `204` `void` No Content
     * @response `403` `ProblemDetails` Forbidden
     * @response `404` `ProblemDetails` Not Found
     */
    asiteRelaticsSyncDeleteRelaticsConfigurationFolderDelete: (
      folderId: string,
      query?: { folderId?: number },
      params: RequestParams = {},
    ) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/${folderId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncAddRelaticsConfigurationFoldersPost
     * @request POST:/api/v2/AsiteRelaticsSync/AddRelaticsConfigurationFolders
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `403` `ProblemDetails` Forbidden
     */
    asiteRelaticsSyncAddRelaticsConfigurationFoldersPost: (
      data: ConfigurationFolderDto[],
      params: RequestParams = {},
    ) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/AddRelaticsConfigurationFolders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncAddAsiteDocumentsSyncClientLogPost
     * @request POST:/api/v2/AsiteRelaticsSync/AddAsiteDocumentsSyncClientLog
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     */
    asiteRelaticsSyncAddAsiteDocumentsSyncClientLogPost: (
      data: AddAsiteDocumentsSyncClientLogCommand,
      params: RequestParams = {},
    ) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/AddAsiteDocumentsSyncClientLog`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncTriggerRelaticsForceSyncPost
     * @request POST:/api/v2/AsiteRelaticsSync/TriggerRelaticsForceSync
     * @secure
     * @response `200` `number` Success
     * @response `401` `ProblemDetails` Unauthorized
     */
    asiteRelaticsSyncTriggerRelaticsForceSyncPost: (data: AddRelaticsForceSyncCommand, params: RequestParams = {}) =>
      this.http.request<number, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/TriggerRelaticsForceSync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncGetErrorsFileGet
     * @request GET:/api/v2/AsiteRelaticsSync/GetErrorsFile
     * @secure
     * @response `200` `(RelaticsImportResults)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteRelaticsSyncGetErrorsFileGet: (query?: { relaticsSyncLogId?: number }, params: RequestParams = {}) =>
      this.http.request<RelaticsImportResults[], ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/GetErrorsFile`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncDownloadXmlFileByRelaticsSyncLogIdAndTypeGet
     * @request GET:/api/v2/AsiteRelaticsSync/DownloadXmlFileByRelaticsSyncLogIdAndType
     * @secure
     * @response `200` `string` Success
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    asiteRelaticsSyncDownloadXmlFileByRelaticsSyncLogIdAndTypeGet: (
      query?: { RelaticsSyncImportLogId?: number; Type?: number },
      params: RequestParams = {},
    ) =>
      this.http.request<string, ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/DownloadXmlFileByRelaticsSyncLogIdAndType`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncGetIdsConfigurationFoldersGet
     * @request GET:/api/v2/AsiteRelaticsSync/GetIdsConfigurationFolders
     * @secure
     * @response `200` `(number)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `403` `ProblemDetails` Forbidden
     */
    asiteRelaticsSyncGetIdsConfigurationFoldersGet: (params: RequestParams = {}) =>
      this.http.request<number[], ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/GetIdsConfigurationFolders`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncGetInfoDocumentsForRelaticsSyncLogItemGet
     * @request GET:/api/v2/AsiteRelaticsSync/GetInfoDocumentsForRelaticsSyncLogItem
     * @secure
     * @response `200` `(RelaticsDocumentsSyncImportLogDto)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `403` `ProblemDetails` Forbidden
     */
    asiteRelaticsSyncGetInfoDocumentsForRelaticsSyncLogItemGet: (
      query?: { RelaticsDocumentsSyncLogId?: number },
      params: RequestParams = {},
    ) =>
      this.http.request<RelaticsDocumentsSyncImportLogDto[], ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/GetInfoDocumentsForRelaticsSyncLogItem`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AsiteRelaticsSync
     * @name AsiteRelaticsSyncGetAllAsiteDocumentsSyncClientLogGet
     * @request GET:/api/v2/AsiteRelaticsSync/GetAllAsiteDocumentsSyncClientLog
     * @secure
     * @response `200` `(AsiteDocumentsSyncClientLogDto)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `403` `ProblemDetails` Forbidden
     */
    asiteRelaticsSyncGetAllAsiteDocumentsSyncClientLogGet: (
      query?: { query?: GetAllAsiteDocumentsSyncClientLogQuery },
      params: RequestParams = {},
    ) =>
      this.http.request<AsiteDocumentsSyncClientLogDto[], ProblemDetails>({
        path: `/api/v2/AsiteRelaticsSync/GetAllAsiteDocumentsSyncClientLog`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  codeTables = {
    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetAppealsDocumentStatusesGet
     * @request GET:/api/v2/licenses/codetables/GetAppealsDocumentStatuses
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetAppealsDocumentStatusesGet: (
      query?: { query?: GetAllAppealDocumentStatusesQuery },
      params: RequestParams = {},
    ) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetAppealsDocumentStatuses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetAppealsInstancesGet
     * @request GET:/api/v2/licenses/codetables/GetAppealsInstances
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetAppealsInstancesGet: (query?: { query?: GetAllAppealInstancesQuery }, params: RequestParams = {}) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetAppealsInstances`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetAppealsStatusesGet
     * @request GET:/api/v2/licenses/codetables/GetAppealsStatuses
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetAppealsStatusesGet: (query?: { query?: GetAllAppealStatusesQuery }, params: RequestParams = {}) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetAppealsStatuses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetDecisionIndicatorsGet
     * @request GET:/api/v2/licenses/codetables/GetDecisionIndicators
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetDecisionIndicatorsGet: (
      query?: { query?: GetAllDecisionIndicatorsQuery },
      params: RequestParams = {},
    ) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetDecisionIndicators`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetIndicatorsGet
     * @request GET:/api/v2/licenses/codetables/GetIndicators
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetIndicatorsGet: (query?: { query?: GetAllIndicatorsQuery }, params: RequestParams = {}) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetIndicators`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetProjectsGet
     * @request GET:/api/v2/licenses/codetables/GetProjects
     * @secure
     * @response `200` `(LicenseCodProjectDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetProjectsGet: (query?: { query?: GetAllLicenseProjectsQuery }, params: RequestParams = {}) =>
      this.http.request<LicenseCodProjectDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetProjects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetProgressesGet
     * @request GET:/api/v2/licenses/codetables/GetProgresses
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetProgressesGet: (query?: { query?: GetAllProgressesQuery }, params: RequestParams = {}) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetProgresses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetSubmittedToGet
     * @request GET:/api/v2/licenses/codetables/GetSubmittedTo
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetSubmittedToGet: (query?: { query?: GetAllSubmittedToQuery }, params: RequestParams = {}) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetSubmittedTo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesGetWorkflowStatusesGet
     * @request GET:/api/v2/licenses/codetables/GetWorkflowStatuses
     * @secure
     * @response `200` `(LicenseCodTableDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesGetWorkflowStatusesGet: (
      query?: { query?: GetLicenseWorkflowStatusesQuery },
      params: RequestParams = {},
    ) =>
      this.http.request<LicenseCodTableDto[], ProblemDetails>({
        path: `/api/v2/licenses/codetables/GetWorkflowStatuses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesAddProjectPost
     * @request POST:/api/v2/licenses/codetables/AddProject
     * @secure
     * @response `201` `LicenseCodTableDto` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    codeTablesAddProjectPost: (data: CreateLicenseCodProjectCommand, params: RequestParams = {}) =>
      this.http.request<LicenseCodTableDto, ProblemDetails>({
        path: `/api/v2/licenses/codetables/AddProject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesUpdateProjectPut
     * @request PUT:/api/v2/licenses/codetables/UpdateProject
     * @secure
     * @response `200` `LicenseCodProjectDto` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesUpdateProjectPut: (data: UpdateLicenseCodProjectCommand, params: RequestParams = {}) =>
      this.http.request<LicenseCodProjectDto, ProblemDetails>({
        path: `/api/v2/licenses/codetables/UpdateProject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CodeTables
     * @name CodeTablesDeleteProjectDelete
     * @request DELETE:/api/v2/licenses/codetables/DeleteProject
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    codeTablesDeleteProjectDelete: (query?: { LicenseCodProjectId?: number }, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/codetables/DeleteProject`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dagboek = {
    /**
     * No description
     *
     * @tags Dagboek
     * @name DagboekAddItemInQueuePost
     * @request POST:/api/Dagboek/AddItemInQueue
     * @secure
     * @response `200` `ApiResponse` Success
     */
    dagboekAddItemInQueuePost: (data: string, params: RequestParams = {}) =>
      this.http.request<ApiResponse, any>({
        path: `/api/Dagboek/AddItemInQueue`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dagboek
     * @name DagboekDownloadReportAsiteGet
     * @request GET:/api/Dagboek/DownloadReportAsite
     * @secure
     * @response `200` `string` Success
     */
    dagboekDownloadReportAsiteGet: (query?: { idDagboek?: string }, params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/api/Dagboek/DownloadReportAsite`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  documentLink = {
    /**
     * No description
     *
     * @tags DocumentLink
     * @name DocumentLinkForceSyncPost
     * @request POST:/api/v2/ProductReservation/DocumentLink/ForceSync
     * @secure
     * @response `200` `DocumentLinksForceSynResponse` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    documentLinkForceSyncPost: (query?: { id?: string }, params: RequestParams = {}) =>
      this.http.request<DocumentLinksForceSynResponse, ProblemDetails>({
        path: `/api/v2/ProductReservation/DocumentLink/ForceSync`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  drainage = {
    /**
     * No description
     *
     * @tags Drainage
     * @name DrainageGetGridDataPost
     * @request POST:/api/v2/Drainage/GetGridData
     * @secure
     * @response `200` `DrainageDtoGridDataResult` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    drainageGetGridDataPost: (data: GetAllDrainageQuery, params: RequestParams = {}) =>
      this.http.request<DrainageDtoGridDataResult, ProblemDetails>({
        path: `/api/v2/Drainage/GetGridData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drainage
     * @name DrainageGetByIdGet
     * @request GET:/api/v2/Drainage/GetById
     * @secure
     * @response `200` `DrainageDetailsDto` Success
     * @response `404` `ProblemDetails` Not Found
     */
    drainageGetByIdGet: (query?: { Id?: number }, params: RequestParams = {}) =>
      this.http.request<DrainageDetailsDto, ProblemDetails>({
        path: `/api/v2/Drainage/GetById`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drainage
     * @name DrainageAddPost
     * @request POST:/api/v2/Drainage/Add
     * @secure
     * @response `201` `DrainageDetailsDto` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    drainageAddPost: (data: CreateDrainageCommand, params: RequestParams = {}) =>
      this.http.request<DrainageDetailsDto, ProblemDetails>({
        path: `/api/v2/Drainage/Add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drainage
     * @name DrainageUpdatePut
     * @request PUT:/api/v2/Drainage/Update
     * @secure
     * @response `200` `DrainageDetailsDto` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    drainageUpdatePut: (data: UpdateDrainageCommand, params: RequestParams = {}) =>
      this.http.request<DrainageDetailsDto, ProblemDetails>({
        path: `/api/v2/Drainage/Update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Drainage
     * @name DrainageDeleteDelete
     * @request DELETE:/api/v2/Drainage/Delete
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    drainageDeleteDelete: (query?: { Id?: number }, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/Drainage/Delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  drainageCod = {
    /**
     * No description
     *
     * @tags DrainageCod
     * @name DrainageCodGetAllCodValuesByCodTypeGet
     * @request GET:/api/v2/DrainageCod/GetAllCodValuesByCodType
     * @secure
     * @response `200` `(any)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    drainageCodGetAllCodValuesByCodTypeGet: (query?: { CodType?: number }, params: RequestParams = {}) =>
      this.http.request<any[], ProblemDetails>({
        path: `/api/v2/DrainageCod/GetAllCodValuesByCodType`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DrainageCod
     * @name DrainageCodGetProjectsGet
     * @request GET:/api/v2/DrainageCod/GetProjects
     * @secure
     * @response `200` `(LicenseCodProjectDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    drainageCodGetProjectsGet: (query?: { query?: GetAllLicenseProjectsQuery }, params: RequestParams = {}) =>
      this.http.request<LicenseCodProjectDto[], ProblemDetails>({
        path: `/api/v2/DrainageCod/GetProjects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DrainageCod
     * @name DrainageCodGetAllCodValuesGet
     * @request GET:/api/v2/DrainageCod/GetAllCodValues
     * @secure
     * @response `200` `DrainageCodValuesViewDto` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    drainageCodGetAllCodValuesGet: (query?: { query?: GetAllCodValuesQuery }, params: RequestParams = {}) =>
      this.http.request<DrainageCodValuesViewDto, ProblemDetails>({
        path: `/api/v2/DrainageCod/GetAllCodValues`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DrainageCod
     * @name DrainageCodGetIndicatorsGet
     * @request GET:/api/v2/DrainageCod/GetIndicators
     * @secure
     * @response `200` `(DrainageCodBaseDto)[]` Success
     * @response `204` `void` No Content
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    drainageCodGetIndicatorsGet: (query?: { query?: GetAllDrainageIndicatorsQuery }, params: RequestParams = {}) =>
      this.http.request<DrainageCodBaseDto[], ProblemDetails>({
        path: `/api/v2/DrainageCod/GetIndicators`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DrainageCod
     * @name DrainageCodAddCodeValuePost
     * @request POST:/api/v2/DrainageCod/AddCodeValue
     * @secure
     * @response `201` `number` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     */
    drainageCodAddCodeValuePost: (data: CreateDrainageCodValueCommand, params: RequestParams = {}) =>
      this.http.request<number, ProblemDetails>({
        path: `/api/v2/DrainageCod/AddCodeValue`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DrainageCod
     * @name DrainageCodUpdateCodeTableValuePut
     * @request PUT:/api/v2/DrainageCod/UpdateCodeTableValue
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    drainageCodUpdateCodeTableValuePut: (data: UpdateDrainageCodValueCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/DrainageCod/UpdateCodeTableValue`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DrainageCod
     * @name DrainageCodDeleteCodeTableValueDelete
     * @request DELETE:/api/v2/DrainageCod/DeleteCodeTableValue
     * @secure
     * @response `200` `void` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    drainageCodDeleteCodeTableValueDelete: (data: DeleteDrainageCodValueCommand, params: RequestParams = {}) =>
      this.http.request<void, ProblemDetails>({
        path: `/api/v2/DrainageCod/DeleteCodeTableValue`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  fastDraftRelaticsSync = {
    /**
     * No description
     *
     * @tags FastDraftRelaticsSync
     * @name FastDraftRelaticsSyncGetRelaticsSyncLogsPost
     * @request POST:/api/v2/FastDraftRelaticsSync/GetRelaticsSyncLogs
     * @secure
     * @response `200` `FastDraftSyncClientLogDtoGridDataResult` Success
     */
    fastDraftRelaticsSyncGetRelaticsSyncLogsPost: (
      data: DataSourceRequest,
      query?: { startDate?: Date; endDate?: Date },
      params: RequestParams = {},
    ) =>
      this.http.request<FastDraftSyncClientLogDtoGridDataResult, any>({
        path: `/api/v2/FastDraftRelaticsSync/GetRelaticsSyncLogs`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastDraftRelaticsSync
     * @name FastDraftRelaticsSyncStartFastDraftRelaticsSyncPost
     * @request POST:/api/v2/FastDraftRelaticsSync/StartFastDraftRelaticsSync
     * @secure
     * @response `200` `void` Success
     * @response `409` `ProblemDetails` Conflict
     */
    fastDraftRelaticsSyncStartFastDraftRelaticsSyncPost: (params: RequestParams = {}) =>
      this.http.request<void, ProblemDetails>({
        path: `/api/v2/FastDraftRelaticsSync/StartFastDraftRelaticsSync`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastDraftRelaticsSync
     * @name FastDraftRelaticsSyncGetFastDraftRelaticsSyncImportLogsGet
     * @request GET:/api/v2/FastDraftRelaticsSync/GetFastDraftRelaticsSyncImportLogs
     * @secure
     * @response `200` `(FastDraftRelaticsSyncImportLogDto)[]` Success
     */
    fastDraftRelaticsSyncGetFastDraftRelaticsSyncImportLogsGet: (
      query?: { ClientLogId?: number },
      params: RequestParams = {},
    ) =>
      this.http.request<FastDraftRelaticsSyncImportLogDto[], any>({
        path: `/api/v2/FastDraftRelaticsSync/GetFastDraftRelaticsSyncImportLogs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastDraftRelaticsSync
     * @name FastDraftRelaticsSyncDownloadXmlFileGet
     * @request GET:/api/v2/FastDraftRelaticsSync/DownloadXmlFile
     * @secure
     * @response `200` `string` Success
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    fastDraftRelaticsSyncDownloadXmlFileGet: (
      query?: { ImportLogId?: number; Type?: number },
      params: RequestParams = {},
    ) =>
      this.http.request<string, ProblemDetails>({
        path: `/api/v2/FastDraftRelaticsSync/DownloadXmlFile`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastDraftRelaticsSync
     * @name FastDraftRelaticsSyncGetTempSyncClientLogsGet
     * @request GET:/api/v2/FastDraftRelaticsSync/GetTempSyncClientLogs
     * @secure
     * @response `200` `(FastDraftRelaticsTempLogDto)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `403` `ProblemDetails` Forbidden
     */
    fastDraftRelaticsSyncGetTempSyncClientLogsGet: (query?: { ClientLogId?: number }, params: RequestParams = {}) =>
      this.http.request<FastDraftRelaticsTempLogDto[], ProblemDetails>({
        path: `/api/v2/FastDraftRelaticsSync/GetTempSyncClientLogs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastDraftRelaticsSync
     * @name FastDraftRelaticsSyncAddFastDraftRelaticsSyncClientLogPost
     * @request POST:/api/v2/FastDraftRelaticsSync/AddFastDraftRelaticsSyncClientLog
     * @secure
     * @response `200` `Unit` Success
     * @response `400` `ProblemDetails` Bad Request
     */
    fastDraftRelaticsSyncAddFastDraftRelaticsSyncClientLogPost: (
      data: AddFastDraftRelaticsSyncClientLogCommand,
      params: RequestParams = {},
    ) =>
      this.http.request<Unit, ProblemDetails>({
        path: `/api/v2/FastDraftRelaticsSync/AddFastDraftRelaticsSyncClientLog`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  license = {
    /**
     * No description
     *
     * @tags License
     * @name LicenseGetOverviewPost
     * @request POST:/api/v2/licenses/License/GetOverview
     * @secure
     * @response `200` `LicenseOverviewDtoGridDataResult` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseGetOverviewPost: (data: GetOverviewDataQuery, params: RequestParams = {}) =>
      this.http.request<LicenseOverviewDtoGridDataResult, ProblemDetails>({
        path: `/api/v2/licenses/License/GetOverview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetDetailsGet
     * @request GET:/api/v2/licenses/License/GetDetails
     * @secure
     * @response `200` `LicenseDetailsDto` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseGetDetailsGet: (query?: { Id?: number }, params: RequestParams = {}) =>
      this.http.request<LicenseDetailsDto, ProblemDetails>({
        path: `/api/v2/licenses/License/GetDetails`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseAddPost
     * @request POST:/api/v2/licenses/License/Add
     * @secure
     * @response `201` `number` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAddPost: (data: CreateLicenseCommand, params: RequestParams = {}) =>
      this.http.request<number, ProblemDetails>({
        path: `/api/v2/licenses/License/Add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseUpdatePut
     * @request PUT:/api/v2/licenses/License/Update
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseUpdatePut: (data: UpdateLicenseCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/License/Update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDeleteDelete
     * @request DELETE:/api/v2/licenses/License/Delete
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseDeleteDelete: (data: DeleteLicenseCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/License/Delete`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseUpdateStatusPost
     * @request POST:/api/v2/licenses/License/UpdateStatus
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseUpdateStatusPost: (data: UpdateWorkflowStatusCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/License/UpdateStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetAllGet
     * @request GET:/api/v2/licenses/License/GetAll
     * @secure
     * @response `200` `(LicensePowerBiDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseGetAllGet: (query?: { command?: GetAllLicensesInfoQuery }, params: RequestParams = {}) =>
      this.http.request<LicensePowerBiDto[], ProblemDetails>({
        path: `/api/v2/licenses/License/GetAll`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseDownloadExcelGet
     * @request GET:/api/v2/licenses/License/DownloadExcel
     * @secure
     * @response `200` `BaseDownloadFile` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `404` `ProblemDetails` Not Found
     */
    licenseDownloadExcelGet: (params: RequestParams = {}) =>
      this.http.request<BaseDownloadFile, ProblemDetails>({
        path: `/api/v2/licenses/License/DownloadExcel`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseGetAllLicensesByProjectIdGet
     * @request GET:/api/v2/licenses/License/GetAllLicensesByProjectId
     * @secure
     * @response `200` `(LicenseInfoDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseGetAllLicensesByProjectIdGet: (query?: { ProjectId?: number }, params: RequestParams = {}) =>
      this.http.request<LicenseInfoDto[], ProblemDetails>({
        path: `/api/v2/licenses/License/GetAllLicensesByProjectId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  licenseAppeal = {
    /**
     * No description
     *
     * @tags LicenseAppeal
     * @name LicenseAppealGetOverviewGet
     * @request GET:/api/v2/licenses/Appeal/GetOverview
     * @secure
     * @response `200` `LicenseAppealGeneralViewModel` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealGetOverviewGet: (query?: { LicenseId?: number }, params: RequestParams = {}) =>
      this.http.request<LicenseAppealGeneralViewModel, ProblemDetails>({
        path: `/api/v2/licenses/Appeal/GetOverview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppeal
     * @name LicenseAppealGetDetailsGet
     * @request GET:/api/v2/licenses/Appeal/GetDetails
     * @secure
     * @response `200` `LicenseAppealDetailsDto` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealGetDetailsGet: (query?: { Id?: number }, params: RequestParams = {}) =>
      this.http.request<LicenseAppealDetailsDto, ProblemDetails>({
        path: `/api/v2/licenses/Appeal/GetDetails`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppeal
     * @name LicenseAppealCreatePost
     * @request POST:/api/v2/licenses/Appeal/Create
     * @secure
     * @response `201` `number` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealCreatePost: (data: CreateLicenseAppealCommand, params: RequestParams = {}) =>
      this.http.request<number, ProblemDetails>({
        path: `/api/v2/licenses/Appeal/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppeal
     * @name LicenseAppealUpdatePut
     * @request PUT:/api/v2/licenses/Appeal/Update
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealUpdatePut: (data: UpdateLicenseAppealCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/Appeal/Update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppeal
     * @name LicenseAppealDeleteDelete
     * @request DELETE:/api/v2/licenses/Appeal/Delete
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealDeleteDelete: (data: DeleteLicenseAppealCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/Appeal/Delete`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppeal
     * @name LicenseAppealUpdateDatesPatch
     * @request PATCH:/api/v2/licenses/Appeal/UpdateDates
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealUpdateDatesPatch: (data: UpdateLicenseAppealsDatesCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/Appeal/UpdateDates`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  licenseAppealDocument = {
    /**
     * No description
     *
     * @tags LicenseAppealDocument
     * @name LicenseAppealDocumentGetDocumentsByAppealIdGet
     * @request GET:/api/v2/licenses/appeal-documents/GetDocumentsByAppealId
     * @secure
     * @response `200` `(LicenseAppealDocumentDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealDocumentGetDocumentsByAppealIdGet: (query?: { AppealId?: number }, params: RequestParams = {}) =>
      this.http.request<LicenseAppealDocumentDto[], ProblemDetails>({
        path: `/api/v2/licenses/appeal-documents/GetDocumentsByAppealId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppealDocument
     * @name LicenseAppealDocumentCreatePost
     * @request POST:/api/v2/licenses/appeal-documents/Create
     * @secure
     * @response `201` `number` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealDocumentCreatePost: (data: CreateLicenseAppealDocumentCommand, params: RequestParams = {}) =>
      this.http.request<number, ProblemDetails>({
        path: `/api/v2/licenses/appeal-documents/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppealDocument
     * @name LicenseAppealDocumentUpdatePut
     * @request PUT:/api/v2/licenses/appeal-documents/Update
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealDocumentUpdatePut: (data: UpdateLicenseAppealDocumentCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/appeal-documents/Update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicenseAppealDocument
     * @name LicenseAppealDocumentDeleteDelete
     * @request DELETE:/api/v2/licenses/appeal-documents/Delete
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licenseAppealDocumentDeleteDelete: (query?: { Id?: number }, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/licenses/appeal-documents/Delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  licensePhase = {
    /**
     * No description
     *
     * @tags LicensePhase
     * @name LicensePhaseGetPhasesGet
     * @request GET:/api/LicensePhase/GetPhases
     * @secure
     * @response `200` `LicensePhaseViewModel` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licensePhaseGetPhasesGet: (query?: { LicenseId?: number }, params: RequestParams = {}) =>
      this.http.request<LicensePhaseViewModel, ProblemDetails>({
        path: `/api/LicensePhase/GetPhases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicensePhase
     * @name LicensePhaseUpdateLicensePhasePost
     * @request POST:/api/LicensePhase/UpdateLicensePhase
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licensePhaseUpdateLicensePhasePost: (data: UpdateLicenseWithPhasesCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/LicensePhase/UpdateLicensePhase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicensePhase
     * @name LicensePhaseCreatePost
     * @request POST:/api/LicensePhase/Create
     * @secure
     * @response `201` `number` Created
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licensePhaseCreatePost: (data: CreateLicensePhaseCommand, params: RequestParams = {}) =>
      this.http.request<number, ProblemDetails>({
        path: `/api/LicensePhase/Create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicensePhase
     * @name LicensePhaseUpdatePut
     * @request PUT:/api/LicensePhase/Update
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licensePhaseUpdatePut: (data: UpdateLicensePhaseCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/LicensePhase/Update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicensePhase
     * @name LicensePhaseDeleteDelete
     * @request DELETE:/api/LicensePhase/Delete
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licensePhaseDeleteDelete: (query?: { Id?: number }, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/LicensePhase/Delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LicensePhase
     * @name LicensePhaseChangePhaseModePost
     * @request POST:/api/LicensePhase/ChangePhaseMode
     * @secure
     * @response `200` `boolean` Success
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    licensePhaseChangePhaseModePost: (
      query?: { LicenseId?: number; NewPhaseMode?: boolean },
      params: RequestParams = {},
    ) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/LicensePhase/ChangePhaseMode`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  security = {
    /**
     * No description
     *
     * @tags Security
     * @name SecurityGetGet
     * @request GET:/api/v2/security/Security/Get
     * @secure
     * @response `200` `(UserRoleDto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `401` `ProblemDetails` Unauthorized
     * @response `404` `ProblemDetails` Not Found
     */
    securityGetGet: (query?: { ModuleName?: string[] }, params: RequestParams = {}) =>
      this.http.request<UserRoleDto[], ProblemDetails>({
        path: `/api/v2/security/Security/Get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityGetModulesGet
     * @request GET:/api/v2/security/Security/GetModules
     * @secure
     * @response `200` `(ModuleV2Dto)[]` Success
     */
    securityGetModulesGet: (query?: { query?: GetModulesQuery }, params: RequestParams = {}) =>
      this.http.request<ModuleV2Dto[], any>({
        path: `/api/v2/security/Security/GetModules`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityGetAdGroupsGet
     * @request GET:/api/v2/security/Security/GetAdGroups
     * @secure
     * @response `200` `(AdGroupDto)[]` Success
     */
    securityGetAdGroupsGet: (query?: { query?: GetAdGroupsQuery }, params: RequestParams = {}) =>
      this.http.request<AdGroupDto[], any>({
        path: `/api/v2/security/Security/GetAdGroups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityGetRolesByModuleIdGet
     * @request GET:/api/v2/security/Security/GetRolesByModuleId
     * @secure
     * @response `200` `(RoleDto)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     */
    securityGetRolesByModuleIdGet: (query?: { ModuleId?: number }, params: RequestParams = {}) =>
      this.http.request<RoleDto[], ProblemDetails>({
        path: `/api/v2/security/Security/GetRolesByModuleId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityGetAdGroupsByRoleIdGet
     * @request GET:/api/v2/security/Security/GetAdGroupsByRoleId
     * @secure
     * @response `200` `AdGroupsAndDataScopesGroupsDto` Success
     * @response `400` `ProblemDetails` Bad Request
     */
    securityGetAdGroupsByRoleIdGet: (query?: { RoleId?: number }, params: RequestParams = {}) =>
      this.http.request<AdGroupsAndDataScopesGroupsDto, ProblemDetails>({
        path: `/api/v2/security/Security/GetAdGroupsByRoleId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityGetDataScopesByModuleIdGet
     * @request GET:/api/v2/security/Security/GetDataScopesByModuleId
     * @secure
     * @response `200` `(AdGroupDataScopeDto)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     */
    securityGetDataScopesByModuleIdGet: (query?: { ModuleId?: number }, params: RequestParams = {}) =>
      this.http.request<AdGroupDataScopeDto[], ProblemDetails>({
        path: `/api/v2/security/Security/GetDataScopesByModuleId`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityGetAdGroupsDataScopesGet
     * @request GET:/api/v2/security/Security/GetAdGroupsDataScopes
     * @secure
     * @response `200` `(DataScopeDto)[]` Success
     * @response `400` `ProblemDetails` Bad Request
     */
    securityGetAdGroupsDataScopesGet: (query?: { RoleId?: number }, params: RequestParams = {}) =>
      this.http.request<DataScopeDto[], ProblemDetails>({
        path: `/api/v2/security/Security/GetAdGroupsDataScopes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityUpdateAdGroupsByRoleIdPost
     * @request POST:/api/v2/security/Security/UpdateAdGroupsByRoleId
     * @secure
     * @response `202` `void` Accepted
     * @response `400` `ProblemDetails` Bad Request
     */
    securityUpdateAdGroupsByRoleIdPost: (data: UpdateAdGroupsByRoleIdCommand, params: RequestParams = {}) =>
      this.http.request<void, ProblemDetails>({
        path: `/api/v2/security/Security/UpdateAdGroupsByRoleId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityAddDataScopePost
     * @request POST:/api/v2/security/Security/AddDataScope
     * @secure
     * @response `201` `boolean` Created
     * @response `400` `ProblemDetails` Bad Request
     */
    securityAddDataScopePost: (data: AddDataScopeCommand, params: RequestParams = {}) =>
      this.http.request<boolean, ProblemDetails>({
        path: `/api/v2/security/Security/AddDataScope`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityUpdateDataScopePost
     * @request POST:/api/v2/security/Security/UpdateDataScope
     * @secure
     * @response `202` `void` Accepted
     * @response `400` `ProblemDetails` Bad Request
     */
    securityUpdateDataScopePost: (data: UpdateDataScopeCommand, params: RequestParams = {}) =>
      this.http.request<void, ProblemDetails>({
        path: `/api/v2/security/Security/UpdateDataScope`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security
     * @name SecurityDeleteDataScopeDelete
     * @request DELETE:/api/v2/security/Security/DeleteDataScope
     * @secure
     * @response `202` `void` Accepted
     * @response `400` `ProblemDetails` Bad Request
     */
    securityDeleteDataScopeDelete: (
      query?: { RoleId?: number; DataScopeId?: number; ValueId?: number },
      params: RequestParams = {},
    ) =>
      this.http.request<void, ProblemDetails>({
        path: `/api/v2/security/Security/DeleteDataScope`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name UserGetAllUserForComboBoxGet
     * @request GET:/api/v2/User/GetAllUserForComboBox
     * @secure
     * @response `200` `(UsersComboBoxDto)[]` Success
     * @response `204` `void` No Content
     * @response `404` `ProblemDetails` Not Found
     */
    userGetAllUserForComboBoxGet: (
      query?: { UserTypeOrganisation?: UserTypeOrganisation },
      params: RequestParams = {},
    ) =>
      this.http.request<UsersComboBoxDto[], ProblemDetails>({
        path: `/api/v2/User/GetAllUserForComboBox`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserRoleByModuleGet
     * @request GET:/api/v2/User/GetUserRoleByModule
     * @secure
     * @response `200` `(UserRoleV2Dto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `404` `ProblemDetails` Not Found
     */
    userGetUserRoleByModuleGet: (data: GetUserRoleByModuleQuery, params: RequestParams = {}) =>
      this.http.request<UserRoleV2Dto[], ProblemDetails>({
        path: `/api/v2/User/GetUserRoleByModule`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetUserRolesByModuleNamesGet
     * @request GET:/api/v2/User/GetUserRolesByModuleNames
     * @secure
     * @response `200` `(UserRoleV2Dto)[]` Success
     * @response `204` `void` No Content
     * @response `400` `ProblemDetails` Bad Request
     * @response `404` `ProblemDetails` Not Found
     */
    userGetUserRolesByModuleNamesGet: (data: GetUserRolesByModuleNamesQuery, params: RequestParams = {}) =>
      this.http.request<UserRoleV2Dto[], ProblemDetails>({
        path: `/api/v2/User/GetUserRolesByModuleNames`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAllUsersForComboBoxByModuleNameAndAndDataScopeAndMethodsAccAppGet
     * @request GET:/api/v2/User/GetAllUsersForComboBoxByModuleNameAndAndDataScopeAndMethodsAccApp
     * @secure
     * @response `200` `(UserModuleView)[]` Success
     * @response `204` `void` No Content
     * @response `404` `ProblemDetails` Not Found
     */
    userGetAllUsersForComboBoxByModuleNameAndAndDataScopeAndMethodsAccAppGet: (
      query?: { ModuleName?: string; DataScopeValue?: number; Source?: ReviewUserSource },
      params: RequestParams = {},
    ) =>
      this.http.request<UserModuleView[], ProblemDetails>({
        path: `/api/v2/User/GetAllUsersForComboBoxByModuleNameAndAndDataScopeAndMethodsAccApp`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetAllUsersByOrganizationIdForComboBoxDagboekGet
     * @request GET:/api/v2/User/GetAllUsersByOrganizationIdForComboBoxDagboek
     * @secure
     * @response `200` `(UsersComboBoxDagboekDto)[]` Success
     * @response `204` `void` No Content
     * @response `404` `ProblemDetails` Not Found
     */
    userGetAllUsersByOrganizationIdForComboBoxDagboekGet: (params: RequestParams = {}) =>
      this.http.request<UsersComboBoxDagboekDto[], ProblemDetails>({
        path: `/api/v2/User/GetAllUsersByOrganizationIdForComboBoxDagboek`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserGetLoggedUserGet
     * @request GET:/api/v2/User/me
     * @secure
     * @response `200` `BasicUserDto` Success
     * @response `404` `ProblemDetails` Not Found
     */
    userGetLoggedUserGet: (params: RequestParams = {}) =>
      this.http.request<BasicUserDto, ProblemDetails>({
        path: `/api/v2/User/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserLogoutPost
     * @request POST:/api/v2/User/Logout
     * @secure
     * @response `200` `void` Success
     */
    userLogoutPost: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/api/v2/User/Logout`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserLogoutEventPost
     * @request POST:/api/v2/User/logout-event
     * @secure
     * @response `200` `Unit` Success
     */
    userLogoutEventPost: (data: LogOutEventCommand, params: RequestParams = {}) =>
      this.http.request<Unit, any>({
        path: `/api/v2/User/logout-event`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
